import { Box } from '@mui/material';
import { withTheme } from '@mui/styles';
import styled from 'styled-components';

export const GroupBar = withTheme(styled(Box)`
  padding-top: 28px;
  display: flex;
  flex-direction: row;
  padding-left: 24px;

  @media only screen and (max-width: 767px) {
    display: flex;
    flex-direction: column;
    padding-left: 0px;
  }

  .round-title {
    height: fit-content;
    width: 74%;
    gap: 8px;
    align-items: flex-start;
    display: flex;
    flex-direction: row;
    font-size: 24px;
  }

  .group-button {
    padding-right: 24px;
    flex-direction: row;
    display: flex;
    align-items: center;

    @media only screen and (max-width: 1023px) and (min-width: 768px) {
      padding-left: 0px;
    }

    @media only screen and (max-width: 767px) {
      padding-left: 0px;
      position: relative;
      left: -12px;
    }

    .group-button-text {
      font-size: 18px;
      @media only screen and (max-width: 1023px) and (min-width: 768px) {
        white-space: nowrap;
      }
    }
  }
`);
